import React from 'react'
import { AnyFunction } from '@codeleap/types'
import { LessonSecondaryCTA } from '@/types'
import { ContributeButton, ShareProgressButton } from '../atoms'

type Props = LessonSecondaryCTA & {
  strategy: AnyFunction
}

export function SecondaryCTA(props: Props) {
  const { enabled, prompt, strategy } = props

  if (enabled && prompt) return <ContributeButton prompt={prompt} onPress={strategy} />
  return <ShareProgressButton onShare={strategy} />
}
